<div class="chat">
  <p-sidebar [(visible)]="display" (onShow)="update()" position="right">
    <div class="sidebar-title">{{ 'CHAT.CHAT' | translate }}</div>
    <div *ngFor="let chat of chatList;">
      <div class="chat-item" (click)="openChat(chat)">
        <div class="d-flex flex-row align-items-center p-2">
          <img class="user-picture"
            [src]="chat.subscriberUserProfilePictureUrl ? chat.subscriberUserProfilePictureUrl:'./assets/images/icons/profile-picture-placeholder-01.svg'"
            alt="profile-picture">
          <i *ngIf="chat.messageRecieved" pBadge severity="danger" style="font-family:'primeicons' !important;"
            value="&#9993;"></i>
          <div class="d-flex flex-column ps-3 w-100">
            <div class="lbl-title">{{chat.eventVenueName}} - {{ (chat.eventName.length>10)? (chat.eventName | slice:0:10)+'...':(chat.eventName) }}</div>
            <div class="d-flex flex-row justify-content-between align-items-center">
              <div class=" lbl-text long-text" style="width:80%;">
                {{chat.subscriberUserFirstName}}&nbsp;{{chat.subscriberUserLastName}}
              </div>
              <div class="lbl-text chat-time ps-1">
                <div *ngFor="let msg of chat.messages; last as last;">
                  <div *ngIf="last">
                    {{msg.createDate | date | date : "MMM, dd hh:mm"}}
                  </div>
                </div>
              </div>
            </div>
            <div *ngFor="let msg of chat.messages; last as last;">
              <div *ngIf="last">
                {{ (msg.messageText.length>20)? (msg.messageText | slice:0:20)+'...':(msg.messageText) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </p-sidebar>

  <i (click)="display = true" class="pi pi-comment" style="font-size:28px; cursor: pointer;">
    <i *ngIf="newMessages" pBadge severity="danger" style="font-family:'primeicons' !important; " value="&#9993;"></i>
  </i>

</div>